<template>
  <transition name="fade">
    <div class="userModal" v-if="show">
      <div class="overlay" v-on:click="close(false)"></div>
      <div :class="{modalContent: true, modalBig: true}">
        <div class="loading" v-if="loading"></div>
        <div class="close" v-on:click="close(false)"></div>
        <h4>Submission Detail</h4>
        <div class="trxCnt" v-if="d">
          <div class="trxItemCnt">
            <div class="trxItem big" v-if="d.timestamp">
              <span>Submision Date</span>
              {{d.timestamp | moment('DD/MM/YYYY HH:mm')}}
            </div>
            <div class="trxItem full" v-if="d.token">
              <span>Token</span>
              {{d.token}}
            </div>
          </div>
          <div class="paymentInfo">
            <h4 class="sectionTitle">Submission information</h4>
            <div class="paymentItem" v-if="d.type === 'subscribe'">
              Email
              <span class="span">{{d.email || '-'}}</span>
            </div>
            <div class="paymentItem" v-if="d.email">
              Email Verified
              <span class="span" v-if="d.emailVerified">Yes</span>
              <span class="span" v-else>No</span>
            </div>
            <div class="paymentItem" v-if="d.language">
              Language
              <span class="span" v-if="d.language === 'id'">
                Bahasa Indonesia
              </span>
              <span class="span" v-else-if="d.language === 'en'">English</span>
              <span class="span" v-else>{{d.language}}</span>
            </div>
            <div class="paymentItem" v-for="(item, i) in d.submission" :key="`dnr${i}`">
              {{item.label}}
              <div v-if="item.type === 'checkbox'" class="span">
                <span v-for="(o, i) in item.options" :key="`opt${i}`">
                  <span v-if="o.selected">{{o.label}}<span
                    v-if="item.options[i + 1] && item.options[i + 1].selected">, </span></span>
                </span>
              </div>
              <span class="span" v-else>{{item.model}}</span>
            </div>
          </div>
          <div class="shippingAddress" v-if="d.form">
            <h4 class="sectionTitle">Form Detail</h4>
            <div class="addrCnt" v-if="d.form.title[lang]">
              <p><b>{{d.form.title[lang]}}</b><br />
              {{d.form.descriptions[lang]}}</p>
            </div>
            <div class="addrCnt" v-else><p><b>Unknown</b><br /></p></div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex';

export default {
  components: {},
  data() {
    return {
      loading: false,
      show: false,
      next: null,
      d: null,
    };
  },
  computed: {
    ...mapState(['lang']),
  },
  methods: {
    open(d, n) {
      this.loading = false;
      this.next = n;
      this.show = true;
      this.d = d;
    },
    close(b, d) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b, d);
    },
  },
};
</script>

<style scoped lang="scss">
.userModal{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 991;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;
  padding: 40px 0;
  .overlay{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,.7);
    z-index: 1;
    // backdrop-filter: saturate(180%) blur(20px);
  }
  .modalContent{
    position: relative;
    z-index: 2;
    background: #fff;
    width: 760px;
    margin: auto;
    border-radius: 5px;
    padding: 30px 0 20px;
    overflow: hidden;
    transition: all .3s ease;
    .loading{
      position: absolute;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: #fff;
      background-color: rgba(255,255,255,.7);
      backdrop-filter: saturate(180%) blur(20px);
      background-image: url(../assets/loading-2.svg);
      background-position: center;
      background-size: 70px auto;
      background-repeat: no-repeat;
      z-index: 9;
    }
    .close{
      width: 36px;
      height: 36px;
      border-radius: 50%;
      background-image: url(../assets/close.png);
      background-size: 14px auto;
      background-position: center;
      background-repeat: no-repeat;
      position: absolute;
      right: 10px;
      top: 10px;
      opacity: .4;
      cursor: pointer;
      transition: all .2s linear;
    }
    .close:hover{
      background-color: #e5e5e5;
      opacity: .7;
    }
    h4{
      font-size: 24px;
      font-weight: 600;
      margin: 0 80px 20px;
    }
    .btnCnt{
      text-align: right;
      border-top: #eee 1px solid;
      margin: 0 -80px -40px;
      padding: 12px 30px 2px;
    }
    .btn{
      margin-left: 5px;
      margin-bottom: 10px;
      &.saving{
        background-color: #ccc;
        color: #999;
        cursor: default;
        box-shadow: none;
      }
    }
    .trxCnt{
      border-top: #eee 1px solid;
      border-bottom: #eee 1px solid;
      max-height: calc(100vh - 240px);
      overflow-y: auto;
      padding: 10px 80px 0;
      box-sizing: border-box;
      .trxItemCnt{
        display: flex;
        flex-wrap: wrap;
        margin: 0 -20px;
        .trxItem{
          width: 50%;
          // display: flex;
          padding: 8px 20px;
          box-sizing: border-box;
          position: relative;
          font-size: 17px;
          &:before{
            content: "";
            position: absolute;
            left: 20px; right: 20px; bottom: 0;
            height: 0; border-top: #ccc 1px dashed;
            display: none;
          }
          span{
            color: #767676;
            margin-right: auto;
            display: block;
            margin-bottom: 2px;
            font-size: 15px;
          }
          &.full{
            width: 100%;
          }
          &.big{
            width: 100%;
            font-size: 24px;
            font-weight: 600;
            span{
              font-weight: normal;
            }
          }
        }
      }
      h4.sectionTitle{
        margin: 30px 0 10px;
        font-size: 22px;
      }
      .productCnt{
        margin-bottom: 48px;
        .productItem{
          position: relative;
          display: flex;
          margin-bottom: 20px;
          .productImg{
            width: 46px; height: 46px;
            background-color: #ccc;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            border-radius: 5px;
            margin-right: 14px;
            &.noImg{
              background-image: url(../assets/image-black.png);
              background-size: 20px auto;
              opacity: .36;
            }
          }
          .productInfo{
            h4{
              margin: 0 0 2px;
              font-size: 16px;
              font-weight: 600;
            }
            p{
              margin: 0;
              color: #767676;
              .bull{
                font-size: 14px;
                margin: 0 6px;
              }
            }
          }
          .subtotal{
            margin-left: auto;
            font-size: 18px;
            font-weight: 600;
          }
        }
      }
      .shippingAddress{
        margin-bottom: 40px;
        .addrCnt{
          display: flex;
          align-items: center;
          p{
            margin: 0;
            padding-right: 20px;
            line-height: 1.4;
            b{
              font-size: 18px;
              font-weight: 600;
            }
          }
        }
      }
      .paymentInfo{
        h4.sectionTitle{
          margin-bottom: 6px;
        }
        .paymentItem{
          border-bottom: #ccc 1px dashed;
          display: flex;
          padding: 10px 0;
          font-size: 17px;
          .span{
            margin-left: auto;
            font-weight: 600;
            text-align: right;
            display: block;
            padding-left: 10px;
          }
          &.discount{
            span{
              color: #0747a6;
            }
          }
        }
      }
      .trxTimeline{
        .tlCnt{
          position: relative;
          margin-top: 20px;
          &:before{
            content: "";
            position: absolute;
            left: 80px; top: -13px;
            width: 13px; height: 13px;
            background-color: #0747a6;
            border-radius: 50%;
            margin-left: -6px;
          }
          .tlItem{
            display: flex;
            .tlLeft{
              width: 80px;
              border-right: #eee 1px solid;
              text-align: center;
              font-weight: 600;
              font-size: 24px;
              text-transform: uppercase;
              position: relative;
              box-sizing: border-box;
              padding-top: 6px;
              &:before{
                content: "";
                position: absolute;
                right: -5px; top: 27px;
                width: 9px; height: 9px;
                background-color: #0747a6;
                border-radius: 50%;
              }
              span{
                display: block;
                font-size: 14px;
              }
            }
            .tlRight{
              width: calc(100% - 80px);
              box-sizing: border-box;
              padding-left: 20px;
              padding-bottom: 30px;
              .tlDate{
                color: #767676;
              }
              h4{
                margin: 0;
                font-size: 18px;
              }
              p{
                margin: 0;
              }
            }
          }
        }
      }
    }
  }
}
</style>
